import angular from "angular";

angular.module("ticketco/common/time_slots", []);
